import React from 'react';
const SVG = ({
    style = {},
    fill = '#444',
    viewBox = '0 0 12 11.448',
    width = '12',
    className = '',
    height = '11.448',
    ...rest
  }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        fill={fill}>
        <g
          id="Group_210">
            <path d="M1.26 10.188V1.932H0v9.516h10.272v-1.26zm9.48-3.876v1.476H3.588V1.26h1.944V0h-3.2v9.048H12V6.312z" class="cls-4"/>
        <g
          id="Group_211" transform="translate(6.468)">
          <path d="M54.3 5.52l3.36-3.36v2.6l1.272-.012L58.92.192 58.728 0h-4.584l-.012 1.26 2.532-.012L53.4 4.524z" class="cls-4" transform="translate(-53.4)"/>
        </g>
     </g>
    </svg>
);
export default SVG;
